import {Box} from 'exsportia-components'
import {FC} from 'react'

import {CheckoutGate} from '../../services/payments/helpers/checkout-gate'
import {InfoMessage} from '../../ui/components/info-message/info-message'
import {useLocale} from '../../utils/i18n'

type Props = {
  gate: CheckoutGate
}

export const CheckoutGateNotice: FC<Props> = ({gate}) => {
  const {l} = useLocale()
  if (!gate.isGated) {
    return null
  }
  const lines = [l('checkout-gate-unavailable')]
  if (gate.hasOtherMethod) {
    lines.push(l('checkout-gate-other-methods'))
  }
  return (
    <Box
      mb='16px'
      role='status'
      data-testid='checkout-gate-notice'
    >
      <InfoMessage
        preset='error'
        text={lines.join(' ')}
      />
    </Box>
  )
}
